import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import RootSvg from 'docs/src/icons/RootSvg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SvgHamburgerMenu(props) {
  return /*#__PURE__*/_jsxs(RootSvg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props, {
    children: [/*#__PURE__*/_jsx("rect", {
      x: 1,
      y: 5,
      width: 14,
      height: 1.5,
      rx: 1,
      fill: "#007FFF"
    }), /*#__PURE__*/_jsx("rect", {
      x: 1,
      y: 9,
      width: 14,
      height: 1.5,
      rx: 1,
      fill: "#007FFF"
    })]
  }));
}